<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Canister Type'" [class]="'kt-portlet__head--lg'"></kt-portlet-header>
	<div class="kt-portlet__body">
		<div class="canister-type col-xl-10 col-md-12 col-sm-12 mt-3 mx-auto">
			<mat-progress-bar *ngIf="isLoading || phase === 'sending'" mode="indeterminate"></mat-progress-bar>

			<div class="canister-type__error" role="alert" *ngIf="loadError">{{ loadError }}</div>

			<div class="canister-type__status canister-type__status--pending" role="status" *ngIf="phase === 'waiting' && state">
				<mat-icon aria-hidden="true">schedule</mat-icon>
				<div class="canister-type__status-text">
					<p class="canister-type__title">{{ waitingTitle }}</p>
					<p>{{ waitingText }}</p>
				</div>
			</div>

			<div class="canister-type__status" role="status" *ngIf="phase === 'not_confirmed' && state">
				<mat-icon aria-hidden="true">history</mat-icon>
				<div class="canister-type__status-text">
					<p class="canister-type__title">Not confirmed yet</p>
					<p>{{ notConfirmedText }}</p>
				</div>
				<button mat-stroked-button type="button" (click)="onCheckAgain()">Check again</button>
			</div>

			<div class="canister-type__status canister-type__status--applied" role="status" *ngIf="phase === 'applied'">
				<mat-icon aria-hidden="true">check_circle</mat-icon>
				<div class="canister-type__status-text">
					<p class="canister-type__title">Applied</p>
					<p>{{ statusMessage }}</p>
				</div>
			</div>

			<div class="canister-type__error" role="alert" *ngIf="phase === 'failed'">{{ statusMessage }}</div>

			<ng-container *ngIf="!isLoading && state">
				<section class="canister-type__section" aria-labelledby="canister-type-current-heading">
					<div class="canister-type__section-head">
						<div>
							<h3 id="canister-type-current-heading" class="canister-type__section-title">Current</h3>
							<p class="canister-type__muted">Serial {{ serialNo }}</p>
						</div>
						<button mat-stroked-button type="button" (click)="onRefresh()" [disabled]="formLocked">Refresh</button>
					</div>

					<div class="canister-type__cards">
						<div class="canister-type__card">
							<span class="canister-type__context-label">
								On the machine
								<span class="canister-type__shadow-term">({{ machineSource === 'registered' ? 'registered' : 'reported' }})</span>
							</span>
							<span class="canister-type__name" *ngIf="machineSource === 'reported'">{{ state.reported }}</span>
							<span class="canister-type__name" *ngIf="machineSource === 'registered'">{{ registered }}</span>
							<span class="canister-type__pill canister-type__pill--unknown" *ngIf="machineSource === 'unknown'">Unknown</span>
							<p class="canister-type__muted" *ngIf="machineSource === 'reported'">The type the machine last confirmed it is set up for.</p>
							<p class="canister-type__muted" *ngIf="machineSource === 'registered'">Not reported by the machine. Assumed from its registration record.</p>
							<p class="canister-type__muted" *ngIf="machineSource === 'unknown'">The machine has not reported a type, and its registration record has none.</p>
						</div>
						<div class="canister-type__card">
							<span class="canister-type__context-label">Requested <span class="canister-type__shadow-term">(desired)</span></span>
							<div class="canister-type__name-row" *ngIf="hasType(state.desired)">
								<span class="canister-type__name">{{ state.desired }}</span>
								<span class="canister-type__pill canister-type__pill--pending" *ngIf="stateLabel() === 'Pending'">Pending</span>
								<span class="canister-type__pill canister-type__pill--applied" *ngIf="stateLabel() === 'Applied'">Applied</span>
							</div>
							<span class="canister-type__pill canister-type__pill--unknown" *ngIf="!hasType(state.desired)">None</span>
							<p class="canister-type__muted" *ngIf="stateLabel() === 'Pending'">Not applied until the machine reports it.</p>
							<p class="canister-type__muted" *ngIf="stateLabel() === 'Applied'">The machine reported this type.</p>
							<p class="canister-type__muted" *ngIf="!hasType(state.desired)">Nothing has been requested for this machine.</p>
						</div>
					</div>
				</section>

				<section class="canister-type__section" aria-labelledby="canister-type-switch-heading">
					<h3 id="canister-type-switch-heading" class="canister-type__section-title">Switch</h3>
					<p class="canister-type__note">
						<mat-icon aria-hidden="true">info_outline</mat-icon>
						<span>This changes the canister setup on the machine. The machine's registration record keeps its canister type.</span>
					</p>
					<div class="canister-type__switch">
						<kt-segmented-control
							[options]="typeOptions"
							[value]="selection"
							[disabled]="formLocked"
							(valueChange)="onSelectionChange($event)">
						</kt-segmented-control>
						<button mat-raised-button color="primary" type="button" (click)="onSwitch()" [disabled]="!canSend">{{ switchLabel }}</button>
					</div>
					<p class="canister-type__muted" *ngIf="selectionIsRequested">{{ selection }} is already requested.</p>
				</section>
			</ng-container>
		</div>
	</div>
</div>
